package ai.jessie.shared.customers

import kotlinx.serialization.Serializable

// UC-012 / FR-012. IDs at the HTTP boundary are public IDs. Omitted child IDs create children;
// omitted existing children are removed only on a confirmed full-record save.
@Serializable
data class CustomerAddressInput(
    val id: String? = null,
    val type: String,
    val line1: String,
    val line2: String? = null,
    val postalCode: String,
    val city: String,
    val countryCode: String,
)

@Serializable
data class CustomerContactInput(
    val id: String? = null,
    val name: String,
    val email: String? = null,
    val phone: String? = null,
    val role: String? = null,
    val billingContact: Boolean = false,
)

@Serializable
data class SaveCustomerRequest(
    val type: String,
    val displayName: String,
    val email: String? = null,
    val phone: String? = null,
    val status: String = "ACTIVE",
    val addresses: List<CustomerAddressInput> = emptyList(),
    val contacts: List<CustomerContactInput> = emptyList(),
    val expectedUpdatedAt: String? = null,
    val confirmed: Boolean = false,
    val duplicateConfirmed: Boolean = false,
)

@Serializable
data class CustomerResponse(
    val id: String,
    val type: String,
    val displayName: String,
    val email: String?,
    val phone: String?,
    val status: String,
    val addresses: List<CustomerAddressInput>,
    val contacts: List<CustomerContactResponse>,
    val createdAt: String,
    val updatedAt: String,
    val hasProjectReferences: Boolean,
    val typeChangeAvailable: Boolean = false,
)

@Serializable
data class CustomerContactResponse(val details: CustomerContactInput, val createdAt: String)

// Separate projection: no general email/phone, non-billing children, lifecycle or project data.
@Serializable
data class CustomerBillingResponse(
    val id: String,
    val displayName: String,
    val addresses: List<CustomerBillingAddress>,
    val contacts: List<CustomerBillingContact>,
)

@Serializable
data class CustomerBillingAddress(
    val line1: String,
    val line2: String?,
    val postalCode: String,
    val city: String,
    val countryCode: String,
)

@Serializable
data class CustomerBillingContact(val name: String, val email: String?, val phone: String?)

@Serializable data class CustomerMatchResponse(val id: String, val displayName: String)

@Serializable data class CustomerPreviewResponse(val duplicates: List<CustomerMatchResponse>)

@Serializable
data class CustomerProblemResponse(
    val code: String,
    val fields: List<String> = emptyList(),
    val duplicates: List<CustomerMatchResponse> = emptyList(),
)
